import { useDownloadFileMutation } from '@/hooks/useDownloadFileMutation';
import Subtitles from '@/images/Subtitles.svg';
import { useAnalytics } from '@/services/analytics';
import { MixPanelEvent } from '@/utils/types';
import { getItemPresenterTypeAndLabels } from '@/utils/utils';
import { LibraryItem } from '@d-id/types';
import MenuItem from '@mui/material/MenuItem';
import { ListItemIcon, ListItemText } from './components';

interface Props {
    video: LibraryItem;
    closeMenu: () => void;
    show?: boolean;
    origin: string;
}

export const ExportSubtitlesMenuItem = ({ video, show, closeMenu, origin }: Props) => {
    const mixpanel = useAnalytics();

    const onCancelDownload = () =>
        mixpanel?.track('options-download', {
            event: MixPanelEvent.CANCEL,
            videoId: video?.id,
            ...getItemPresenterTypeAndLabels(video as LibraryItem),
        });
    const { mutateAsync: download } = useDownloadFileMutation(onCancelDownload);

    if (!show) {
        return null;
    }

    return (
        <MenuItem
            disabled={!video.subtitles_url}
            onClick={() => {
                download({
                    dataurl: video!.subtitles_url!,
                    filename: video!.name ?? 'video',
                    extension: '.srt',
                });
                mixpanel?.track('export-subtitles', { from: origin });
                closeMenu();
            }}>
            <ListItemIcon>
                <img src={Subtitles} />
            </ListItemIcon>
            <ListItemText>Export subtitles (.srt)</ListItemText>
        </MenuItem>
    );
};
